module.exports = __webpack_public_path__ + "static/img/img4.a2e5e81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qmyd/qgz/img4.png
// module id = osHR
// module chunks = 36